import React from 'react'
import classnames from 'classnames'

export const ManagedConversationsList = (props) => {
  const { conversations, onSetCurrentConversation, currentConversation, 
          onShowNewManagedConversationModal, conversationOptions } = props
  const showButton = (conversationOptions.length > 0)

  return (
    <div className="d-flex flex-wrap border-bottom">
      {
        !!conversations && conversations.map((conversation=>(
          <ManagedConversation
            key={conversation.id}
            currentConversation={currentConversation}
            onSetCurrentConversation={onSetCurrentConversation}
            conversation={conversation}/>
        )))
      }
      {
        showButton &&
        <div
          style={{width: (conversations.length % 2) == 0 ? '320px' : '160px', height: '160px'}}
          onClick={onShowNewManagedConversationModal}
          className="d-flex align-items-center justify-content-center hoverable clickable flex-column border-bottom border-right">
          <div className="fas fa-plus fa-lg"/>
          {
            <b className="d-block text-center pt-3">Add Group Message</b>
          }
        </div>
      }
    </div>
  )
}

const ManagedConversation = ({ conversation, onSetCurrentConversation, currentConversation }) => (
  <div 
    onClick={()=>onSetCurrentConversation(conversation)}
    style={{width: '160px', height: '160px'}}
    className={classnames("p-4 d-flex align-items-center border-bottom border-right clickable hoverable cursor-default unselectable w-50", { "bg-primary": currentConversation.id == conversation.id })}>
    <div className="w-100 text-center h-100 w-100 d-flex flex-column justify-content-center align-items-center">
      <b className="d-block w-100 text-center pt-3 ">{ conversation.subject }</b>
      <div 
        style={{ width: '10px', height: '10px', borderRadius: '5px' }} 
        className={classnames("mt-3", { "bg-primary": conversation.unreadCount > 0 })}/>
    </div>
  </div>
)